import { render, staticRenderFns } from "./ShareInvoices.vue?vue&type=template&id=33501396&scoped=true&"
import script from "./ShareInvoices.vue?vue&type=script&lang=js&"
export * from "./ShareInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ShareInvoices.vue?vue&type=style&index=0&id=33501396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33501396",
  null
  
)

export default component.exports